import { Controller } from "@hotwired/stimulus"

// Controller for filtering table rows
export default class extends Controller {
  static targets = ["input", "table"]
  
  filter() {
    const filterValue = this.inputTarget.value.toLowerCase()
    const rows = this.tableTarget.querySelectorAll('tbody tr')
    
    rows.forEach(row => {
      const cells = row.querySelectorAll('td')
      let match = false
      
      cells.forEach(cell => {
        if (cell.textContent.toLowerCase().includes(filterValue)) {
          match = true
        }
      })
      
      row.style.display = match ? '' : 'none'
    })
  }
}

